import React from 'react';

export default function RatingBadge({ rating }) {
  if (!rating) return null;
  return <span className={`badge badge-${rating}`}>{rating}</span>;
}
